import { resolveRelease } from './release';

export const SENTRY_SERVICE_NAME = 'invitecloud-frontend';

function firstNonEmpty(...values: Array<string | undefined>): string | undefined {
  return values.find((value) => typeof value === 'string' && value.trim().length > 0)?.trim();
}

function normalizeEnvironment(value?: string): string {
  const normalized = value?.trim().toLowerCase();

  if (normalized === 'local' || normalized === 'dev') return 'development';
  if (normalized === 'stage') return 'staging';
  if (normalized === 'prod') return 'production';
  if (normalized === 'development' || normalized === 'staging' || normalized === 'production') {
    return normalized;
  }

  return normalized || 'development';
}

export function resolveSentryEnvironment(explicitEnvironment?: string): string {
  return normalizeEnvironment(
    firstNonEmpty(
      explicitEnvironment,
      import.meta.env.VITE_SENTRY_ENV,
      import.meta.env.NEXT_PUBLIC_SENTRY_ENV,
      import.meta.env.VITE_APP_ENV,
      import.meta.env.VITE_DEPLOY_ENV,
      import.meta.env.MODE,
      'development',
    ),
  );
}

export function getSentryConfig() {
  const environment = resolveSentryEnvironment();
  const release = resolveRelease();
  const serverName = typeof window === 'undefined' ? SENTRY_SERVICE_NAME : window.location.host;

  return {
    dsn: firstNonEmpty(import.meta.env.VITE_SENTRY_DSN),
    environment,
    release,
    serverName,
    serviceName: import.meta.env.VITE_SENTRY_SERVICE_NAME || SENTRY_SERVICE_NAME,
    tracesSampleRate: Number(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE || 0),
    debug: import.meta.env.VITE_SENTRY_DEBUG === 'true',
    smokeTest: import.meta.env.VITE_SENTRY_SMOKE_TEST === 'true',
  };
}
